<template>
  <v-main>
    <v-container>
      <br />
      <v-row justify="start">
        <v-col style="min-width: 145px">
          <span class="text-h5 font-weight-bold" v-text="'Categories'"></span>
          <AddButton :link="'/categories/create'"></AddButton>
        </v-col>
      </v-row>
      <loader v-if="isLoading"></loader>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left sr_no_class">Sr No</th>
                    <th class="text-left" style="min-width: 57px">Name</th>
                    <th class="text-left" style="min-width: 80px">is Active</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(category, i) in categories" :key="category.name">
                    <td>{{ i + 1 }}</td>
                    <td style="min-width: 125px">{{ category.name }}</td>
                    <td>{{ category.is_active ? "TRUE" : "FALSE" }}</td>
                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/categories/${category.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import AddButton from "@/components/addbutton.vue";
import Loader from "@/components/loader.vue";

export default {
  name: "CategoriesPage",
  data() {
    return {
      categories: [],
      isLoading: false,
    };
  },
  components: {
    AddButton,
    Loader,
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let categories = await axios.get(`categories`);
      this.categories = categories.data.data;
      this.isLoading = false;
    },
  },
};
</script>
